import { formatAddress } from './address';

export const sortDeliveryPointByAddressComparator = (
  a: DeliveryPointDto,
  b: DeliveryPointDto
) => formatAddress(a.address).localeCompare(formatAddress(b.address));
